import axios from 'axios'

export async function getProductsToReview () {
  const response = await axios.get('/?fc=module&module=dbs_productsreviews&controller=api&action=getProductsToReview')
  const products = response.data.products

  if (products) {
    return products
  } else {
    throw new Error('Can not get products to review')
  }
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getProductsToReview.js